import React from "react";
import { ColumnProps } from "types/models";
const columns: ColumnProps[] = [
  {
    title: "STT",
    dataIndex: "STT",
    show: true,
    render(value, record, index) {
      return <div>{index + 1}</div>;
    },
    align: "center",
  },
  { title: "Tên bệnh sử", dataIndex: "benhSu", show: true, align: "left" },
  { title: "Ghi chú", dataIndex: "ghiChu", show: true, align: "left" },
];
export { columns };

export const data3Col = [
  {
    key: 1,
    none: "Không liệt điều tiết",
    sph: "",
    cyl: "",
    axis: "",
  },
  {
    key: 2,
    none: "-",
    sph: "",

    cyl: "",
    axis: "",
  },
  {
    key: 3,
    none: "-",
    sph: "",
    cyl: "",
    axis: "",
  },
];

export const data4Col = [
  {
    key: 1,
    none: "Xa",
    sph: "",
    cyl: "",
    axis: "",
    vision: null,
  },
  {
    key: 2,
    none: "Add",
    sph: "",
    cyl: "",
    axis: "",
    vision: null,
  },
  {
    key: 3,
    none: "Gần",
    sph: "",
    cyl: "",
    axis: "",
    vision: null,
  },
];

export const data1ColRT = [
  {
    key: 1,
    none: "Xa",
    sph: "",
    cyl: "",
    axis: "",
    reflexType: "",
  },
];

export const data6Col = [
  {
    key: 1,
    none: "Xa",
    ucva: "",
    sph: "",
    cyl: "",
    axis: "",
    vision: "",
    va: "",
  },
  {
    key: 2,
    none: "Add",
    ucva: "",
    sph: "",
    cyl: "",
    axis: "",
    vision: "",
    va: "",
  },
  {
    key: 3,
    none: "Gần",
    ucva: "",
    sph: "",
    cyl: "",
    axis: "",
    vision: "",
    va: "",
  },
];
